import { toString } from 'lodash';
export default function(value: any): string {
    return value ? toString(Math.round(parseFloat(value) * 100)) : value;
}
